import { Agent } from "@shared/models/agent";
import { CheckVinResponse } from "../check-vin/CheckVinResponse";
import { TerminationType } from "../TerminationType";


export class TerminationRequest {
  type: string = "termination_request";
  policyNumber: string;
  terminationType: TerminationType;
  cancelDate: string;
  refundType: number;
  iban?: string
  fullName: string;
  street: string;
  orientationNumber: string;
  city: string;
  zip: string;
  countryCode: string;
  lobId: number;
  motor?: TerminationRequestMotor;
  paymentBlockageFlag: boolean;
   // privat
}

export class TerminationRequestMotor{
  crn: string; // ECV
  vin: string;
  mtplPolicies: Array<CheckVinResponse> = [];
  paymentBlockageFlag: boolean;
}
